<template>
    <div class="bg-slate-50 sm:py-8">
        <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="relative overflow-hidden bg-white ring-inset ring-slate-200 sm:rounded-2xl sm:ring-1">
                <div class="mx-auto min-h-dvh max-w-7xl px-4 py-8 sm:min-h-0 sm:px-8 sm:py-12">
                    <!-- <h2 class="text-center text-xl font-bold">Lift-Check</h2> -->

                    <FunnelProgressBar
                        :progress="progress"
                        :show-back-button="stepStack.length > 1 && currentStep.key !== 'success'"
                        @prevStep="prevStep"
                        :currentGroup="groups[currentStep.group - 1]"
                        :groups="groups"
                    />
                    <form @submit.prevent="">
                        <div v-auto-animate>
                            <component
                                :key="currentStep.id"
                                :is="currentStep.component"
                                :step="currentStep"
                                :form="form"
                                @step-submitted="(nextKey) => nextStep(form, nextKey)"
                                @next-step-clicked="$emit('next-step-clicked')"
                            />
                        </div>
                    </form>

                    <div class="mx-auto mt-4 max-w-xl text-sm leading-6 text-red-600 sm:flex-1">
                        <ul>
                            <li
                                v-for="(error, field) in $page.props.errors"
                                :key="field"
                                class="list-item list-inside list-disc"
                            >
                                {{ error }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { useGtm } from '@gtm-support/vue-gtm'
const gtm = useGtm()

import FunnelProgressBar from '@/Components/Funnel/FunnelProgressBar.vue'
import { useFunnel } from '@/Composables/funnel.js'
import { useStairliftFunnel } from '@/Composables/stairlift-funnel-steps.js'

const props = defineProps({
    eid: String,
})

const form = useForm({
    key: 'stairlift.funnel',
    orderer: '',
    stairlift_type: '',
    stairlift_location: '',
    stairlift_form: '',
    stairlift_floor: '',

    accident_dependent: '',
    accident_cause: '',
    social_care: '',

    care_dependent_people: 0,
    state: '',

    first_consultation: '',

    house_type: '',
    housing_status: '',
    lift_needed_by: '',
    stair_width: '',

    contact: {
        salutation: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        street: '',
        zip: '',
        city: '',
    },
    accept_terms: false,
    accept_newsletter: false,
})

const eventCallback = (key) => {
    sendTagEvent(key)
}

const { funnel, steps, groups } = useStairliftFunnel()
const { stepStack, currentStep, progress, nextStep, prevStep } = useFunnel(funnel, steps, eventCallback)

function sendTagEvent(key) {
    switch (key) {
        case 'stairlift_floor':
            gtm.trackEvent({
                event: 'stairlift_base_questions_submitted',
                eid: props.eid,
            })
            break
        case 'estimation':
            gtm.trackEvent({
                event: 'stairlift_finance_questions_submitted',
                eid: props.eid,
            })
            break
        case 'stair_width':
            gtm.trackEvent({
                event: 'stairlift_partner_questions_submitted',
                eid: props.eid,
            })
            break
        case 'contact':
            gtm.trackEvent({
                event: 'stairlift_contact_form_submitted',
                eid: props.eid,
                user_email: form.email,
                user_phone: form.phone,
            })
            break
        default:
            break
    }
}

onMounted(() => {
    gtm.trackEvent({
        event: 'stairlift_funnel_viewed',
        eid: props.eid,
    })
})
</script>
